import parse from "html-react-parser";
import LoginExternalServiceDenied from "../components/Structure/Login/modals/LoginExternalServiceDenied/index.tsx";
import { useModal } from "contexts/modalContext/modalContext.js";
import { ButtonA } from "components/Elements/Button/Button.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUser } from "contexts/userContext/userContext.js";

const CustomErrorSimpleModal = ({ errObj }) => {
  const { getTextByKey, getHtmlByKey, getLanguage } = useContent();

  const messageText = parse(
    `${getTextByKey(errObj.errorMessage)} <p className="bold">${
      errObj.organizationDomain
    }</p> ${getTextByKey("sub-user-must-join-organization-subtext")}`
  );

  return (
    <div className="simple-content-container">
      <div className="simple-content-title title">
        {getHtmlByKey("sub-user-must-join-organization-title")}
      </div>
      <div className="simple-content-message">{messageText}</div>
      <div className="buttons-container">
        {!errObj.customDomain ? (
          <ButtonA
            title={getTextByKey("join-organization")}
            page={`invite/${errObj.encryptedDomain}`}
          />
        ) : (
          <ButtonA
            title={getTextByKey("join-organization")}
            href={`${errObj.customDomain}/${getLanguage()}/invite/${
              errObj.encryptedDomain
            }`}
          />
        )}
      </div>
    </div>
  );
};

const useCustomLoginErrorHandler = () => {
  const { setModal } = useModal();
  const { logout } = useUser();

  const handleCustomError = (errData) => {
    // auto logout when user was logged in but organization changed login type settings
    if (errData?.includes?.("sub-user-is-forced-to-logout")) {
      const errObj = JSON.parse(errData);
      const allowedLoginServices = Object.keys(
        errObj.availableAuthenticationOptions
      ).filter((key) => errObj.availableAuthenticationOptions[key]);

      setModal(() => (
        <LoginExternalServiceDenied
          allowedLoginServices={allowedLoginServices}
        />
      ));

      return;
    }
    
    //  Deny to login sub user with the not allowed (by top user) login service
    if (errData?.includes?.("microsoft") || errData?.includes?.("google")) {
      const message = JSON.parse(errData);

      // Get last word of the response which represents the allowed login service
      const allowedLoginServices = Object.keys(message).filter(
        (key) => message[key]
      );

      setModal(() => (
        <LoginExternalServiceDenied
          allowedLoginServices={allowedLoginServices}
        />
      ));

      logout();

      return;
    }

    // deny login/signup if organization restricted to using this email outside organization
    if (errData?.includes?.("sub-user-must-join-organization")) {
      const errObj = JSON.parse(errData);

      setModal({
        modal: CustomErrorSimpleModal,
        props: {
          errObj,
        },
      });

      return;
    }
  };

  return handleCustomError;
};

export default useCustomLoginErrorHandler;
